import { useCallback, useEffect, useRef } from 'react';

export interface LatestRequestContext {
  signal: AbortSignal;
  isCurrent: () => boolean;
}

function useLatestRequest() {
  const lastId = useRef(0);
  const controller = useRef<AbortController | null>(null);

  useEffect(() => {
    return () => {
      controller.current?.abort();
    };
  }, []);

  return useCallback(<T,>(task: (context: LatestRequestContext) => Promise<T>) => {
    const id = lastId.current + 1;
    lastId.current = id;
    controller.current?.abort();
    const currentController = new AbortController();
    controller.current = currentController;

    return task({
      signal: currentController.signal,
      isCurrent: () => id === lastId.current,
    });
  }, []);
}

export default useLatestRequest;
